(function () {
  const LIFT_GATE_VARIANT_ID = '49080021483828';
  const LIFT_GATE_REQUIRED = true;

  // ==========================================================================
  //  Helpers
  // ==========================================================================
  function isLiftGateCard(el) {
    var card = el.closest ? el.closest('product-card[data-lift-gate="true"]') : null;
    return !!card;
  }

  function getCardData(card) {
    return {
      variantId: card.dataset.variantId,
      productTitle: card.dataset.productTitle,
      productPrice: card.dataset.productPrice,
      productImage: card.dataset.productImage,
      productUrl: card.dataset.productUrl,
      hasOnlyDefaultVariant: card.dataset.hasOnlyDefaultVariant === 'true'
    };
  }

  // ==========================================================================
  //  Shared modal (from lift-gate-modal.liquid) — used for single-variant
  //  products on collection grids. Multi-variant products use the Quick Add
  //  Drawer instead (see section below).
  // ==========================================================================
  var modalState = { variantId: null, productUrl: null, hasOnlyDefaultVariant: true };

  function getModal() { return document.getElementById('lift-gate-modal'); }

  function openModal(data) {
    var modal = getModal();
    if (!modal) {
      console.warn('[lift-gate] Modal not found. Include lift-gate-modal in theme.liquid.');
      if (data.productUrl) window.location.href = data.productUrl;
      return;
    }

    modalState.variantId = data.variantId;
    modalState.productUrl = data.productUrl;
    modalState.hasOnlyDefaultVariant = !!data.hasOnlyDefaultVariant;

    var titleEl = modal.querySelector('#lg-modal-title');
    var priceEl = modal.querySelector('#lg-modal-price');
    var imageEl = modal.querySelector('#lg-modal-image');
    var submitBtn = modal.querySelector('#lg-modal-submit');

    if (titleEl) titleEl.textContent = data.productTitle || '';
    if (priceEl) priceEl.textContent = data.productPrice || '';
    if (imageEl) {
      if (data.productImage) {
        imageEl.src = data.productImage;
        imageEl.alt = data.productTitle || '';
      } else {
        imageEl.removeAttribute('src');
      }
    }
    if (submitBtn) {
      submitBtn.textContent = 'Add to Cart';
      submitBtn.disabled = false;
    }

    modal.querySelectorAll('input[name="lg_modal_choice"]').forEach(function (r) { r.checked = false; });
    modal.classList.remove('has-error');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lg-modal-open');
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.classList.remove('has-error');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lg-modal-open');
  }

  function handleModalSubmit() {
    var modal = getModal();
    if (!modal) return;

    var chosen = modal.querySelector('input[name="lg_modal_choice"]:checked');
    if (!chosen) {
      modal.classList.add('has-error');
      return;
    }
    modal.classList.remove('has-error');

    var submitBtn = modal.querySelector('#lg-modal-submit');
    var liftGateValue = chosen.value === 'lift_gate_required'
      ? 'Required'
      : 'No Lift Gate Needed';

    submitBtn.textContent = 'Adding...';
    submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: modalState.variantId,
        quantity: 1,
        properties: { 'Lift Gate Delivery': liftGateValue }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      if (chosen.value !== 'lift_gate_required') return null;
      // Only add the fee if it's not already in the cart — prevents
      // duplicate $100 charges when multiple lift-gate items are added.
      return fetch('/cart.js').then(function (cr) { return cr.json(); }).then(function (cart) {
        var existingFee = cart.items.find(function (item) {
          return String(item.variant_id) === String(LIFT_GATE_VARIANT_ID);
        });
        if (existingFee) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: LIFT_GATE_VARIANT_ID,
            quantity: 1,
            properties: { '_lift_gate_fee': 'true' }
          })
        });
      });
    }).then(function () {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.refresh(true);
        setTimeout(function () {
          cartDrawer.open && cartDrawer.open();
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          cartDrawer.dispatchEvent(new CustomEvent('on:cart-drawer:open', { bubbles: true }));
        }, 300);
      } else {
        window.location.href = '/cart';
      }
      submitBtn.textContent = 'Added!';
      setTimeout(function () {
        closeModal();
        submitBtn.textContent = 'Add to Cart';
        submitBtn.disabled = false;
      }, 900);
    }).catch(function (err) {
      console.error('[lift-gate] Cart add error:', err);
      submitBtn.textContent = 'Try Again';
      submitBtn.disabled = false;
    });
  }

  function bindModal() {
    var modal = getModal();
    if (!modal || modal.dataset.lgBound === 'true') return;
    modal.dataset.lgBound = 'true';

    modal.querySelectorAll('[data-lg-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    modal.querySelectorAll('input[name="lg_modal_choice"]').forEach(function (r) {
      r.addEventListener('change', function () { modal.classList.remove('has-error'); });
    });
    var submitBtn = modal.querySelector('#lg-modal-submit');
    if (submitBtn) submitBtn.addEventListener('click', handleModalSubmit);
  }

  // ==========================================================================
  //  Helper — check the customer's previous lift gate decision (if any).
  //  Returns a Promise resolving to one of:
  //    'required'     — cart has at least one product with "Required" property
  //                     (and the $100 fee line item is present)
  //    'no_lift_gate' — cart has at least one product with "No Lift Gate Needed"
  //                     property (customer already opted out on a prior item)
  //    null           — customer has not yet made any lift gate decision
  //
  //  We use this to skip the modal on subsequent lift-gate products —
  //  whichever choice the customer made first, we apply it to the next item.
  // ==========================================================================
  function previousLiftGateChoice() {
    return fetch('/cart.js').then(function (r) {
      return r.json();
    }).then(function (cart) {
      var hasRequired = false;
      var hasNoLiftGate = false;
      cart.items.forEach(function (item) {
        var prop = item.properties && item.properties['Lift Gate Delivery'];
        if (!prop) return;
        if (prop.indexOf('Required') !== -1) hasRequired = true;
        else if (prop.indexOf('No Lift Gate') !== -1) hasNoLiftGate = true;
      });
      if (hasRequired) return 'required';
      if (hasNoLiftGate) return 'no_lift_gate';
      return null;
    }).catch(function () {
      return null;
    });
  }

  // ==========================================================================
  //  Helper — add a lift-gate product directly to cart, skipping the modal.
  //  Applies the customer's previous choice to the new product.
  // ==========================================================================
  function addLiftGateProductDirectly(data, priorChoice) {
    var propertyValue = priorChoice === 'no_lift_gate'
      ? 'No Lift Gate Needed'
      : 'Required';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: data.variantId,
        quantity: 1,
        properties: { 'Lift Gate Delivery': propertyValue }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.refresh(true);
        setTimeout(function () {
          cartDrawer.open && cartDrawer.open();
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          cartDrawer.dispatchEvent(new CustomEvent('on:cart-drawer:open', { bubbles: true }));
        }, 300);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      console.error('[lift-gate] Direct add error:', err);
    });
  }

  // ==========================================================================
  //  Collection grid interception
  //  Theme has two card forms:
  //   A) <form class="js-product-form"> for single-variant → submits directly
  //   B) <button class="js-quick-add"> for multi-variant → opens quick-add-drawer
  //  We intercept both paths for lift-gate cards.
  //
  //  Behavior: If the cart already has the lift-gate fee, skip the modal and
  //  auto-apply "Required" to the new product (customer already opted in).
  //  Otherwise, show the modal so the customer can make an explicit choice.
  // ==========================================================================
  function handleGridClick(e) {
    // PATH A: form submit on single-variant card
    var atcBtn = e.target.closest('button[name="add"]');
    if (atcBtn) {
      var form = atcBtn.closest('form.js-product-form');
      if (form && isLiftGateCard(form)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var card = form.closest('product-card[data-lift-gate="true"]');
        var data = getCardData(card);

        previousLiftGateChoice().then(function (priorChoice) {
          if (priorChoice) {
            // Customer already made a lift gate decision — apply it silently.
            addLiftGateProductDirectly(data, priorChoice);
          } else {
            // First lift gate product — ask them.
            openModal(data);
          }
        });
        return;
      }
    }

    // PATH B: quick-add button on multi-variant card → let drawer open,
    //   then inject selector once drawer loads (handled by observer below).
    //   We just need to mark it so the drawer injection knows to fire.
    var quickAddBtn = e.target.closest('.js-quick-add');
    if (quickAddBtn && isLiftGateCard(quickAddBtn)) {
      var card2 = quickAddBtn.closest('product-card[data-lift-gate="true"]');
      window.__liftGatePendingDrawer = getCardData(card2);
    }
  }

  // ==========================================================================
  //  Quick Add Drawer injection
  //  The theme's quick-add-drawer fetches product HTML and puts it into
  //  its own content area. Our PDP already has lift-gate-selector.liquid
  //  which will come along for the ride — but the drawer form submits
  //  via its own logic, so we need to hook its submit event.
  // ==========================================================================
  function enhanceQuickAddDrawer(drawer) {
    if (drawer.dataset.lgEnhanced === 'true') return;
    drawer.dataset.lgEnhanced = 'true';

    // When drawer content loads with a lift-gate-selector inside, pre-select
    // the radio matching the customer's previous lift gate choice — whether
    // that was "Lift Gate Needed" or "No Lift Gate Needed."
    if ('MutationObserver' in window) {
      var contentObs = new MutationObserver(function () {
        var selector = drawer.querySelector('#lift-gate-selector');
        if (!selector || selector.dataset.lgPrefilled === 'true') return;
        var requiredRadio = drawer.querySelector('input[name="lift_gate_choice"][value="lift_gate_required"]');
        var noLiftGateRadio = drawer.querySelector('input[name="lift_gate_choice"][value="no_lift_gate"]');
        if (!requiredRadio || !noLiftGateRadio) return;
        selector.dataset.lgPrefilled = 'true';
        previousLiftGateChoice().then(function (priorChoice) {
          if (!priorChoice) return;
          var target = priorChoice === 'required' ? requiredRadio : noLiftGateRadio;
          if (!target.checked) {
            target.checked = true;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
      contentObs.observe(drawer, { childList: true, subtree: true });
    }

    // Hook all form submits inside the drawer
    drawer.addEventListener('submit', function (e) {
      if (!window.__liftGatePendingDrawer) return;
      var form = e.target.closest('form');
      if (!form) return;

      var selector = drawer.querySelector('#lift-gate-selector');
      if (!selector) return; // not a lift-gate product — let drawer handle normally

      var chosen = drawer.querySelector('input[name="lift_gate_choice"]:checked');
      if (LIFT_GATE_REQUIRED && !chosen) {
        e.preventDefault();
        e.stopImmediatePropagation();
        selector.classList.add('has-error');
        selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      selector.classList.remove('has-error');
      if (chosen) {
        var hidden = form.querySelector('input[name="properties[Lift Gate Delivery]"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'properties[Lift Gate Delivery]';
          form.appendChild(hidden);
        }
        hidden.value = chosen.value === 'lift_gate_required'
          ? 'Required'
          : 'No Lift Gate Needed';
      }
    }, true);

    // Clear pending flag when drawer closes; also clear prefill flag so next
    // product opening the drawer gets re-checked against current cart state.
    drawer.addEventListener('on:drawer:close', function () {
      window.__liftGatePendingDrawer = null;
      var selector = drawer.querySelector('#lift-gate-selector');
      if (selector) {
        delete selector.dataset.lgPrefilled;
      }
    });
  }

  // ==========================================================================
  //  Product Detail Page — inline selector (unchanged behavior)
  // ==========================================================================
  function initProductPageForm() {
    var selector = document.getElementById('lift-gate-selector');
    if (!selector) return;
    var form = document.querySelector('form.js-product-form-main');
    if (!form) return;

    // Pre-select the radio matching the customer's previous lift gate choice
    // — whether that was "Lift Gate Needed" or "No Lift Gate Needed."
    previousLiftGateChoice().then(function (priorChoice) {
      if (!priorChoice) return;
      if (document.querySelector('input[name="lift_gate_choice"]:checked')) return;
      var targetValue = priorChoice === 'required' ? 'lift_gate_required' : 'no_lift_gate';
      var targetRadio = document.querySelector('input[name="lift_gate_choice"][value="' + targetValue + '"]');
      if (targetRadio) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    form.addEventListener('submit', function (e) {
      var chosen = document.querySelector('input[name="lift_gate_choice"]:checked');
      if (LIFT_GATE_REQUIRED && !chosen) {
        e.preventDefault();
        e.stopImmediatePropagation();
        selector.classList.add('has-error');
        selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      selector.classList.remove('has-error');
      if (chosen) {
        var hidden = form.querySelector('input[name="properties[Lift Gate Delivery]"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'properties[Lift Gate Delivery]';
          form.appendChild(hidden);
        }
        hidden.value = chosen.value === 'lift_gate_required'
          ? 'Required'
          : 'No Lift Gate Needed';
      }
    }, true);

    document.querySelectorAll('input[name="lift_gate_choice"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        selector.classList.remove('has-error');
      });
    });
  }

  // ==========================================================================
  //  Cart fee sync — unchanged
  // ==========================================================================
  function syncLiftGateFee() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var needsFee = cart.items.some(function (item) {
        var prop = item.properties && item.properties['Lift Gate Delivery'];
        return prop && prop.indexOf('Required') !== -1;
      });
      var feeItem = cart.items.find(function (item) {
        return String(item.variant_id) === String(LIFT_GATE_VARIANT_ID);
      });

      if (needsFee && !feeItem) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: LIFT_GATE_VARIANT_ID,
            quantity: 1,
            properties: { '_lift_gate_fee': 'true' }
          })
        }).then(function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.refresh(true);
        });
      } else if (!needsFee && feeItem) {
        var updates = {};
        updates[LIFT_GATE_VARIANT_ID] = 0;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.refresh(true);
        });
      } else if (needsFee && feeItem && feeItem.quantity > 1) {
        // Fee line exists but got duplicated (e.g. customer added a second
        // lift-gate product which triggered another add). Force back to 1.
        var capUpdates = {};
        capUpdates[LIFT_GATE_VARIANT_ID] = 1;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: capUpdates })
        }).then(function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.refresh(true);
        });
      }
    }).catch(function (e) {
      console.error('[lift-gate] Fee sync error:', e);
    });
  }

  // ==========================================================================
  //  Boot
  // ==========================================================================
  function boot() {
    bindModal();
    initProductPageForm();

    // Grid click interception — delegated, so new cards from AJAX work
    document.addEventListener('click', handleGridClick, true);

    // Enhance the quick-add-drawer when it exists
    var drawer = document.querySelector('quick-add-drawer');
    if (drawer) enhanceQuickAddDrawer(drawer);

    // Watch for drawer being added dynamically
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('quick-add-drawer')) {
              enhanceQuickAddDrawer(node);
            } else if (node.querySelector) {
              var d = node.querySelector('quick-add-drawer');
              if (d) enhanceQuickAddDrawer(d);
            }
          });
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('on:cart:add', syncLiftGateFee);
  document.addEventListener('on:line-item:change', syncLiftGateFee);
})();